/* eslint-disable */
import Api from '@/api/services/Api';

const route = '/history'

export default {
    get: params => {
        let customRoute = `${route}`
        switch (params.historialEstado) {
            case "2": customRoute = `${route}?type=created`
                break;
            case "3": customRoute = `${route}?type=updated`
                break;
            case "4": customRoute = `${route}?type=deleted`
                break;
            case "5": customRoute = `${route}?type=disabled`
                break;
            case "6": customRoute = `${route}?${params.customfilter}`
                break;
            default: break;
        }
        return Api().get(customRoute, { params })
    },
    loadHistorialesTimeLine: params => Api().get(`${route}${params.classParam}`, { params }),
}
